const urls = {
  "qa": 'https://qa.api.nestv2.buhoms.com/',
  "local": 'http://localhost:4000/'
}

export const environment = {
  baseUrl: urls.qa,
  googleMapsApiKey: 'AIzaSyBW0IiaJg0_rEu21LTBEEBiDSEpMLEzuSU',
};
